import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {Template} from "../model/template";
import {TemplateFilters} from "../model/filters/template-filters";
import {TemplatesResponse} from "../model/responses/templates-response";
import {TemplatePersistRequest} from "../model/requests/template-persist-request";

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  private readonly templatesURL: string;

  constructor(private http: HttpClient) {
    this.templatesURL = '/catalog/templates';
  }

  public getTemplate(templateUuid: string): Observable<{ template: Template }> {
    const url = `${this.templatesURL}/${templateUuid}`;
    return this.http.get<{ template: Template }>(url);
  }

  public getTemplates(offset?: number, limit?: number, filters?: TemplateFilters): Observable<TemplatesResponse> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new TemplateFilters();
    return this.http.post<TemplatesResponse>(this.templatesURL, body, options);
  }

  public getTemplateSummaries(filters?: TemplateFilters): Observable<{ templates: Template[] }> {
    const body = (filters != null) ? filters : new TemplateFilters();
    const url = `${this.templatesURL}/summary`;
    return this.http.post<{ templates: Template[] }>(url, body);
  }

  public createTemplate(templateCreationData: TemplatePersistRequest): Observable<any> {
    const url = `${this.templatesURL}/create`;
    return this.http.post<any>(url, templateCreationData);
  }

  public editTemplate(templateEditionData: TemplatePersistRequest): Observable<any> {
    const url = `${this.templatesURL}/edit`;
    return this.http.post<any>(url, templateEditionData);
  }

  public deleteTemplate(templateUuid: string) {
    let url = `${this.templatesURL}/${templateUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteTemplates(uuids: string[]): Observable<HttpResponse<any>> {
    const url = `${this.templatesURL}/delete`;
    return this.http.post<any>(url, uuids, {observe: 'response'});
  }
}
